export const Footer = () => {

    let year = new Date().getFullYear();

    return (
        <div className="copyright text-center">
            <div className="wrapper">
                <p className="copy-footer-29">© {year} Mind Help Ltd. | All rights reserved.</p>
            </div>
        </div>
    )
}